import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class EditEntityPersonSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {personSearch: (this.props.personSearch !== null) && (this.props.personSearch !== undefined) ? this.props.personSearch : false};

        this.changeFlag = this.changeFlag.bind(this);

        this.blurAction = this.blurAction.bind(this);
    }

    changeFlag(event) {
        let newVal = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.setState({
            personSearch: newVal
        }, this.blurAction);
    }

    blurAction() {
        if (this.props.personSearch !== this.state.personSearch) {
            this.props.onBlur("personSearch", this.state.personSearch);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.personSearch !== this.props.personSearch) {
            this.setState({personSearch: nextProps.personSearch})
        }
    }


    render() {
        return (
            <div className="edit-third-party__about__input-group">
                <input type="checkbox"
                       id="edit-third-party__about__personSearch"
                       name="personSearch"
                       checked={this.state.personSearch}
                       onChange={this.changeFlag} />
                <span>
                    <label className="row-label" htmlFor="edit-third-party__about__personSearch">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.personSearchLabel" />
                    </label>
                </span>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityPersonSearch.jsx